import { faMessage, faPhone } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import './Delivery_Partner.css'

const Delivery_Partner = () => {
    return (
        <div className='delivery_partner_div'>
            <div className='left_side_div'>
                <div className='img_holder'>
                    <img
                        src={
                            process.env.PUBLIC_URL +
                            "/assets/Image/my_order/man.png"
                        }
                    />
                </div>

                <h3 className='delivery_boy_name'>Ajju is delivery partner</h3>

            </div>

            <div className='contact_icon_holder'>
                <div className='icon_holder'>
                    <FontAwesomeIcon icon={faMessage} className='message_icon' />
                </div>

                <div className='icon_holder'>
                    <FontAwesomeIcon icon={faPhone} className='message_icon' />
                </div>
            </div>

        </div>
    )
}

export default Delivery_Partner
